import type { ListBuilderList } from '../../../types';

/**
 * PD-16652 — the Check Your Records lists' order: the server's group order
 * (`duplicateGroupOrder`: riskiest reason first, then the group's 90-day
 * sales, a group's rows together). The only sort those lists offer — the
 * shared compliance sorts rank single rows by their account's sales, which
 * would scatter a group's rows across the pages.
 */
export const DUPLICATE_GROUP_SORT_OPTIONS: NonNullable<
	ListBuilderList['sortOptions']
> = [
	{
		id: 'group-risk',
		name: 'Riskiest Group First',
		description: 'Groups in the order the card ranks them, rows together',
		fields: [
			{
				direction: 'ASC',
				fieldName: 'duplicateGroupOrder',
				objectTable: 'client_license',
			},
		],
	},
];
